import React, {Fragment, useEffect, useRef, useState} from "react";
import * as ReactDOM from 'react-dom';
import JqxTable from "../../../../../share-components/table/JqxTable";
import {toast} from "react-toastify";
import * as ReactDOMServer from "react-dom/server";
import {applyPriceRounding} from "../index";

const priceChangedCellClass = (row, columnfield, value, data) => {
    if (data.is_price_manually_changed) {
        return 'price-changed-row';
    }
    return '';
};

const OrderProductJqx = (props) => {
    const {setValue, trigger, getValues, orderedProducts, setButtonDisable, currency, useRrp} = props;
    let gridRef = useRef(null);
    let selectRef = useRef(null);
    const [orderData, setOrderData] = useState([]);

    const datafields = [
        {name: 'variant_id', type: 'number'},
        {name: 'product_id', type: 'number'},
        {name: 'product_name', type: 'string'},
        {name: 'image', type: 'string'},
        {name: 'sku', type: 'string'},
        {name: 'variant_name', type: 'string'},
        {name: 'quantity', type: 'number'},
        {name: 'price', type: 'number'},
        {name: 'total_price', type: 'number'},
        {name: 'stock', type: 'number'},
        {name: 'original_base_price', type: 'number'},
        {name: 'base_rrp', type: 'number'},
        {name: 'base_price', type: 'number'},
        {name: 'is_price_manually_changed', type: 'bool'},
    ];

    const columns = [
        {datafield: 'variant_id', hidden: true},
        {datafield: 'stock', hidden: true},
        {datafield: 'total_price', hidden: true},
        {datafield: 'original_base_price', hidden: true},
        {datafield: 'base_rrp', hidden: true},
        {datafield: 'base_price', hidden: true},
        {datafield: 'is_price_manually_changed', hidden: true},
        {
            text: 'Product',
            datafield: 'product_name',
            editable: false,
            columntype: 'text',
            width: '50%',
            cellclassname: priceChangedCellClass,
            cellsrenderer(row, columnfield, value, defaulthtml, columnproperties) {
                const productDetails = getValues('ordered_products')[row];
                const html = ReactDOMServer.renderToString(
                    <div style={{textAlign: 'center', padding: 5}}>
                        {productDetails && <div className="row">
                            <div className="col-md-3">
                                <img className="img-fluid" src={productDetails.image} width="40" alt=""/>
                            </div>
                            <div className="col-md-9" style={productDetails.is_price_manually_changed ? {color: '#dc3545'} : {}}>
                                <div className="row">
                                    <p className={productDetails.is_price_manually_changed ? '' : 'font-primary'}>{value}</p>
                                </div>
                                <div className="row">
                                    <p>{productDetails.variant_name}</p>
                                </div>
                                <div className="row">
                                    <p>{productDetails.sku}</p>
                                </div>

                            </div>

                        </div>}
                    </div>
                );
                return html;
            },

        },
        {
            text: 'Quantity',
            datafield: 'quantity',
            editable: true,
            columntype: 'text',
            width: '25%',
            cellsalign: 'right',
            cellclassname: priceChangedCellClass,
            validation: function (cell, value) {
                const stock = gridRef.getcellvalue(cell.row, 'stock');
                if (Number(value) <= 0) {
                    setButtonDisable(true);
                    toast.error("Quantity must be greater than zero.", {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    return {result: false, message: "Quantity must be greater than zero."}
                } else if (Number(stock) < Number(value)) {
                    setButtonDisable(true);
                    toast.error("Only "+stock + " is available", {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    return {result: false, message: "Only "+stock + " is available"}
                } else {
                    setButtonDisable(false);
                    return true;
                }
            },
        },
        {
            text: 'Price',
            datafield: 'price',
            editable: true,
            columntype: 'text',
            width: '20%',
            cellsalign: 'right',
            cellclassname: priceChangedCellClass,
            cellsrenderer(row, columnfield, value, defaulthtml, columnproperties) {
                const sym = currency ? currency.symbol : '£';
                const html = `<div style="text-align: right; padding: 5px; margin-top: 25px;">${sym}${parseFloat(value).toFixed(2)}</div>`;
                return html;
            },
            validation: function (cell, value) {
                if (Number(value) < 0) {
                    return {result: false, message: "Price cannot be negative."}
                }
                return true;
            },
        }
    ];

    const getJqxRef = jqx => {
        if (jqx) {
            gridRef = jqx;

            setTimeout(
                () => {
                    if (gridRef) {
                        const myEle = document.getElementById(gridRef._id);
                        if (myEle) {
                            gridRef.updatebounddata();
                        }
                    }

                    // myGrid.updatebounddata();
                },
                1000
            );
        }
    };

    const onDelete = (data) => {
        setDataToHookForm();
    }

    const cellEdit = event => {
        const rowArgs = event.args;

        if (rowArgs.datafield === "price") {
            const currentProducts = getValues('ordered_products');
            const product = currentProducts[rowArgs.rowindex];
            const oldPrice = product?.price;
            const newPrice = Number(rowArgs.value);

            if (oldPrice !== newPrice) {
                const rate = currency ? currency.rate : 1;
                const originalBase = useRrp ? product.base_rrp : product.original_base_price;
                const currencyValue = currency ? currency.value : 'GBP';
                const originalDisplayPrice = applyPriceRounding(originalBase * rate, currencyValue);
                const isStillChanged = Math.abs(newPrice - originalDisplayPrice) >= 0.01;

                gridRef.setcellvalue(rowArgs.rowindex, "price", newPrice);
                const qty = gridRef.getcellvalue(rowArgs.rowindex, 'quantity');
                gridRef.setcellvalue(rowArgs.rowindex, "total_price", newPrice * qty);
                gridRef.setcellvalue(rowArgs.rowindex, "base_price", newPrice / rate);
                gridRef.setcellvalue(rowArgs.rowindex, "is_price_manually_changed", isStillChanged);
                setDataToHookForm();
                return;
            }

            gridRef.setcellvalue(rowArgs.rowindex, rowArgs.datafield, rowArgs.value);
            setDataToHookForm();
            return;
        }

        if (rowArgs.datafield === "quantity") {
            const singlePrice = gridRef.getcellvalue(rowArgs.rowindex, 'price');
            gridRef.setcellvalue(rowArgs.rowindex, "total_price", rowArgs.value * singlePrice);
        }
        gridRef.setcellvalue(rowArgs.rowindex, rowArgs.datafield, rowArgs.value);
        setDataToHookForm();
    };

    const setDataToHookForm = () => {
        let orderData = [];

        const gridInformation = gridRef.getdatainformation();
        for (let i = 0; i < gridInformation.rowscount; i++) {
            const rowData = gridRef.getrowdata(i);
            orderData.push(rowData);
        }
        setValue('ordered_products_new', orderData);
        trigger('ordered_products_new');

        setValue('ordered_products', orderData);
        trigger('ordered_products');
    }

    const hasPriceChanged = getValues('ordered_products').some(item => item.is_price_manually_changed);

    return (
        <Fragment>
            <style>{`
                .price-changed-row {
                    color: #dc3545 !important;
                }
            `}</style>

            <div style={{width: '100%'}}>
                {hasPriceChanged && (
                    <div className="py-2 mb-2" style={{fontSize: 13, color: '#dc3545'}}>
                        <i className="fa fa-info-circle mr-2"></i>
                        Highlighted rows indicate that the product price has been manually modified from the original price.
                    </div>
                )}
                {getValues('ordered_products').length > 0 && <JqxTable
                    key={currency ? currency.value : 'GBP'}
                    rowsheight={75}
                    datafields={datafields}
                    columns={columns}
                    data={getValues('ordered_products')}
                    myGrid={gridRef}
                    getJqxRef={getJqxRef}
                    isDelete
                    onCellendedit={cellEdit}
                    disableCreateRow
                    onDelete={onDelete}
                    isFirstDelete={true}
                    deleteAll={true}
                    editmode={'dblclick'}
                />}
            </div>
        </Fragment>
    );
}

function areEqual(prevProps, nextProps) {
    console.log(JSON.stringify(prevProps.getValues), JSON.stringify(nextProps.getValues));
    return JSON.stringify(prevProps.orderedProducts) == JSON.stringify(nextProps.orderedProducts);
    /*
    return true if passing nextProps to render would return
    the same result as passing prevProps to render,
    otherwise return false
    */
}

export default OrderProductJqx;
